import { render, staticRenderFns } from "./StickerPanel.vue?vue&type=template&id=83f88034&scoped=true&"
import script from "./StickerPanel.vue?vue&type=script&lang=js&"
export * from "./StickerPanel.vue?vue&type=script&lang=js&"
import style0 from "./StickerPanel.vue?vue&type=style&index=0&id=83f88034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f88034",
  null
  
)

export default component.exports